import {useReducer, useState} from 'react';

import {merchantService} from '@/services/merchants';
import type {AfriexID} from '@/types';
import type {BusinessAllowedFeature} from '@/types/AfriexBusiness';
import {getErrorMessage} from '@/utils/errorMessage';
import {showErrorMessage} from '@/utils/showErrorMessage';
import {showSuccessMessage} from '@/utils/showSuccessMessage';

import {allowedFeatureReducer} from './allowedFeatureReducer';
import {pruneAllowedFeatureTree} from './utils';
const defaultData = {
  tree: [] as BusinessAllowedFeature[],
};
export const useAllowedFeatureUpdate = (initialData = defaultData) => {
  const [state, dispatch] = useReducer(allowedFeatureReducer, initialData);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (
    businessId: AfriexID,
    rawFeatures: BusinessAllowedFeature[],
  ) => {
    setIsLoading(true);
    try {
      const validFeatures = pruneAllowedFeatureTree(rawFeatures);
      await merchantService.updateBusinessAllowedFeature(
        businessId,
        validFeatures,
      );
      showSuccessMessage(`Business feature updated successfully`);

      // onClose();

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (e) {
      showErrorMessage(
        `Error saving business allowed feature ${getErrorMessage(e, String(e))}`,
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    dispatch,
    handleSubmit,
    isLoading,
    state,
  };
};
